const decodeBase64Url = (value) => {
  if (!value) return '';
  let base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padLength = base64.length % 4;
  if (padLength) {
    base64 += '='.repeat(4 - padLength);
  }
  const binary = atob(base64);
  const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
  return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
};

const decodeBase64UrlJson = (value) => {
  try {
    const payload = JSON.parse(decodeBase64Url(value));
    return payload && typeof payload === 'object' && !Array.isArray(payload)
      ? payload
      : null;
  } catch (_error) {
    return null;
  }
};

export const decodeJwtPayload = (token) => {
  const segments = String(token || '').split('.');
  if (segments.length !== 3 || !segments[1]) return null;

  return decodeBase64UrlJson(segments[1]);
};

let pendingAuthHandoff = null;
let pendingVerificationHandoff = null;
let hasPendingAuthHandoff = false;
let hasPendingVerificationHandoff = false;

const clearSensitiveHash = () => {
  if (typeof window === 'undefined') return;
  const nextUrl = `${window.location.pathname}${window.location.search}`;
  window.history.replaceState(
    null,
    typeof document === 'undefined' ? '' : document.title,
    nextUrl,
  );
};

const captureSensitiveHandoff = () => {
  if (typeof window === 'undefined') return;
  const hash = String(window.location.hash || '');

  if (hash.startsWith('#auth=')) {
    pendingAuthHandoff = hash.slice('#auth='.length).split('&', 1)[0];
    hasPendingAuthHandoff = true;
    if (window.name) window.name = '';
    clearSensitiveHash();
    return;
  }

  if (hash.startsWith('#verify=')) {
    pendingVerificationHandoff = hash.slice('#verify='.length).split('&', 1)[0];
    hasPendingVerificationHandoff = true;
    clearSensitiveHash();
  }
};

export const hasAuthHandoffPayload = () => {
  captureSensitiveHandoff();
  return hasPendingAuthHandoff;
};

export const readAuthHandoffPayload = () => {
  captureSensitiveHandoff();
  if (!hasPendingAuthHandoff) return null;
  const encoded = pendingAuthHandoff;
  pendingAuthHandoff = null;
  hasPendingAuthHandoff = false;
  return decodeBase64UrlJson(encoded);
};

export const readVerificationHandoffPayload = () => {
  captureSensitiveHandoff();
  if (!hasPendingVerificationHandoff) return null;
  const encoded = pendingVerificationHandoff;
  pendingVerificationHandoff = null;
  hasPendingVerificationHandoff = false;
  return decodeBase64UrlJson(encoded);
};

// Capture and scrub before React mounts or any page-lifecycle effect can run.
captureSensitiveHandoff();
if (typeof window !== 'undefined') {
  window.addEventListener('hashchange', captureSensitiveHandoff);
}

